import React from "react";
import { IconProps } from "../../utils/global-types/global-types";

const DocumentAddedIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <path
        d="M11.0827 2.77856C10.963 2.66076 10.8304 2.55676 10.6876 2.46851V4.81976C10.6876 4.9391 10.735 5.05356 10.8194 5.13795C10.9038 5.22235 11.0182 5.26976 11.1376 5.26976H13.4888C13.4006 5.12688 13.2966 4.99435 13.1788 4.87466L11.0827 2.77856Z"
        fill="currentColor"
      />
      <path
        d="M11.5201 6.18748C11.1624 6.18641 10.8196 6.04384 10.5667 5.7909C10.3137 5.53795 10.1712 5.1952 10.1701 4.83748V2.16448C10.0711 2.15548 9.97661 2.13748 9.87311 2.13748H5.6701C5.07337 2.13748 4.50107 2.37453 4.07911 2.79649C3.65716 3.21845 3.4201 3.79074 3.4201 4.38748V13.3875C3.4201 13.9842 3.65716 14.5565 4.07911 14.9785C4.50107 15.4004 5.07337 15.6375 5.6701 15.6375H11.9701C12.5668 15.6375 13.1391 15.4004 13.5611 14.9785C13.9831 14.5565 14.2201 13.9842 14.2201 13.3875V6.48448C14.2201 6.38098 14.2021 6.28648 14.1931 6.18748H11.5201ZM10.6201 9.78748H9.27011V11.1375C9.27011 11.2568 9.22269 11.3713 9.1383 11.4557C9.05391 11.5401 8.93945 11.5875 8.82011 11.5875C8.70076 11.5875 8.5863 11.5401 8.50191 11.4557C8.41752 11.3713 8.37011 11.2568 8.37011 11.1375V9.78748H7.02011C6.90076 9.78748 6.7863 9.74007 6.70191 9.65568C6.61752 9.57129 6.57011 9.45683 6.57011 9.33748C6.57011 9.21813 6.61752 9.10367 6.70191 9.01928C6.7863 8.93489 6.90076 8.88748 7.02011 8.88748H8.37011V7.53748C8.37011 7.41813 8.41752 7.30368 8.50191 7.21928C8.5863 7.13489 8.70076 7.08748 8.82011 7.08748C8.93945 7.08748 9.05391 7.13489 9.1383 7.21928C9.22269 7.30368 9.27011 7.41813 9.27011 7.53748V8.88748H10.6201C10.7395 8.88748 10.8539 8.93489 10.9383 9.01928C11.0227 9.10367 11.0701 9.21813 11.0701 9.33748C11.0701 9.45683 11.0227 9.57129 10.9383 9.65568C10.8539 9.74007 10.7395 9.78748 10.6201 9.78748Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DocumentAddedIcon;
